<template>
  <div class="caption">
    Download Progress: {{ currentTotalString }} of {{ downloadTotalString }}
    <v-progress-linear v-model="asPercentage" height="16" class="text-white">
      <span :class="{ 'white--text': asPercentage > 50 }">{{ asPercentage }}%</span>
    </v-progress-linear>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'DownloadProgress',
  props: {
    downloadCurrent: {
      type: Number,
      required: true,
      default: () => 0
    },
    downloadTotal: {
      type: Number,
      required: true,
      default: () => 0
    }
  },
  data: () => ({
    loading: false,
    override: null
  }),
  computed: {
    asPercentage () {
      if (this.override) return this.override;
      if (this.downloadTotal <= 0) return 0;
      return Math.round((this.downloadCurrent / this.downloadTotal) * 100);
    },
    currentTotalString () {
      if (this.override) return 'Override';
      if (this.downloadCurrent < 1000) return `${this.downloadCurrent.toFixed(2)} Bytes`;
      else if (this.downloadCurrent < 1000000) return `${(this.downloadCurrent / 1000).toFixed(2)} Kb`;
      else if (this.downloadCurrent < 1000000000) return `${(this.downloadCurrent / 1000000).toFixed(2)} Mb`;
      else return `${(this.downloadCurrent / 1000000000).toFixed(2)} Gb`;
    },
    downloadTotalString () {
      if (this.override) return 'Override';
      if (this.downloadTotal < 1000) return `${this.downloadTotal.toFixed(2)} Bytes`;
      else if (this.downloadTotal < 1000000) return `${(this.downloadTotal / 1000).toFixed(2)} Kb`;
      else if (this.downloadTotal < 1000000000) return `${(this.downloadTotal / 1000000).toFixed(2)} Mb`;
      else return `${(this.downloadTotal / 1000000000).toFixed(2)} Gb`;
    }
  }
};
</script>
